const normalize = value => String(value || '').toLowerCase().normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();

// Match the destination as a whole: mentioning a customer inside a fiscal task
// must never become a request to open Customers.
const destinations = [
  { id: 'agenda', aliases: ['agenda', 'minha agenda', 'calendario'] },
  { id: 'forms', aliases: ['formulario', 'formularios', 'construtor de formularios'] },
  { id: 'courses', aliases: ['curso', 'cursos', 'treinamentos'] },
  { id: 'finance', aliases: ['financeiro', 'financas'] },
  { id: 'requests', aliases: ['solicitacao', 'solicitacoes', 'minhas solicitacoes'] },
  { id: 'automation-hub', aliases: ['automacao', 'automacoes', 'automacoes e ia', 'robos'] },
  { id: 'file-manager', aliases: ['arquivo', 'arquivos', 'gerenciador de arquivos'] },
  { id: 'user-manual', aliases: ['manual', 'manual do usuario'] },
  { id: 'profile', aliases: ['perfil', 'meu perfil'] },
  { id: 'nfse-manager', aliases: ['nota', 'notas', 'nf', 'nfs', 'nfse', 'nfs e', 'nota fiscal', 'notas fiscais', 'gerenciador de nfs', 'gerenciador nfs', 'gerenciador de notas', 'gerenciador de notas fiscais'] },
  { id: 'customers', aliases: ['cliente', 'clientes', 'cadastro de clientes'] },
  { id: 'electronic-signatures', aliases: ['assinatura', 'assinaturas', 'assinatura eletronica', 'assinaturas eletronicas', 'assinaturas digitais'] },
  { id: 'student-management', aliases: ['aluno', 'alunos', 'gestao de alunos', 'aprendiz', 'aprendizes', 'gestao de aprendiz', 'gestao de aprendizes', 'gestao dos aprendizes'] },
  { id: 'attendee-management', aliases: ['atendido', 'atendidos', 'gestao de atendidos'] },
  { id: 'young-apprentice-invoice', aliases: ['nota fatura', 'notas fatura'] },
  { id: 'mural', aliases: ['mural', 'muralk'] },
  { id: 'project-bank', aliases: ['projeto', 'projetos', 'banco de projetos'] },
];

export function resolveNashMenuRequest(prompt, menuItems = [], history = []) {
  const query = normalize(prompt);
  const command = /^(?:(?:oi|ola|nash|por favor|eu quero|quero|preciso|gostaria de|pode|poderia|voce pode|me|que voce|que vc) )*(?:abrir|abra|abre|acessar|acesse|entrar|entre|entra|ir|va|vai|me leve|me leva|me leve para|me leva para|levar|leve|leva|mostrar|mostre|mostra|fechar|feche|fecha)\b\s*(?:para |pra |em |na |no |nas |nos |ao |aos |a |o |as |os )*/;
  const location = /^(?:como (?:eu |faco para |posso )?(?:entrar|acessar|abrir)|onde (?:fica|esta|encontro)|qual (?:e )?o caminho para)\s+(?:para |em |na |no |nas |nos |ao |aos |a |o |as |os )*/;
  const correction = /^nao\b.*?\bnao\s+(?:a |o )?/;
  const prefix = command.test(query) ? command : location.test(query) ? location : correction.test(query) ? correction : null;
  if (!prefix) return null;
  let target = query.replace(prefix, '').replace(/^(?:aba|tela|modulo) (?:de |do |da )?/, '')
    .replace(/ (?:por favor|pra mim|para mim|mesmo)$/, '').trim();
  const items = Array.isArray(menuItems) ? menuItems : [];
  if (prefix === command && /^(essa tela|esta tela|esse modulo|essa aba|ela|ele|isso|ai|la)?$/.test(target)) {
    // A pronoun never authorizes a new action by itself. Here there is already
    // an explicit command; use one unambiguous destination from recent turns.
    for (const turn of [...history].reverse().slice(0, 8)) {
      const text = ` ${normalize(turn.content)} `;
      const matches = items.filter(item => item.id && (text.includes(` ${normalize(item.label)} `)
        || destinations.some(entry => entry.id === item.id && entry.aliases.some(alias => text.includes(` ${alias} `)))));
      const unique = [...new Map(matches.map(item => [item.id, item])).values()];
      if (unique.length === 1) { target = normalize(unique[0].label); break; }
      if (unique.length > 1) return { text: 'Qual dessas telas você quer abrir? Diga o nome da aba.', localOnly: true };
    }
    if (!target || /^(essa tela|esta tela|esse modulo|essa aba|ela|ele|isso|ai|la)$/.test(target)) {
      return { text: 'Qual tela você quer abrir? Diga o nome da aba.', localOnly: true };
    }
  }
  target = target.replace(/^(?:meus|minhas|meu|minha) /, '');
  const destination = destinations.find(entry => entry.aliases.includes(target));
  const item = destination ? items.find(entry => entry.id === destination.id)
    : items.find(entry => entry.id && (normalize(entry.label) === target || normalize(entry.path) === target));
  if (!item) {
    if (!destination || !items.some(entry => entry.id)) return null;
    return { text: 'Essa tela não está disponível no menu da sua conta. Confira seu acesso com o administrador.', localOnly: true };
  }
  const label = item.label || target;
  const action = prefix === command ? { type: /\b(fechar|feche|fecha)\b/.test(query) ? 'close-tab' : 'open-tab', tabId: item.id, tabLabel: label } : null;
  return { text: action ? `${action.type === 'close-tab' ? 'Fechando' : 'Abrindo'} ${label}.` : `📍 ${item.path || label}`, action, localOnly: true, skipStructure: true };
}
